// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEKompanive_containerDashboardP__OefGj","mobileResponsive":"TabelaEKompanive_mobileResponsive__9rccd"};